<template>
  <div id="app" style="position: relative;">
    <router-view />

    <div class="lang-btn" @click="onClickLang">
      {{ lang }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { wsApi } from "@/utils/apiConfig";
import { downloadFile, translateString } from "./utils/utils";
import { getLangData, getTipsLangData } from "./api/api";



export default {
  name: "App",
  data() {
    return {
      ws: null,
      notifyCount: 0, // 保证key的刷新，0~9循环
      lang: 'CN'
    };
  },
  computed: {
    ...mapGetters(["getToken", "getProjectId", "getUser", "getLangData"]),
  },
  watch: {
    async getUser(newVal) {
      let ws = await this.getWs();
      if (newVal.id != undefined) {
        if (ws && ws.readyState == 1) {
          let params = {
            type: "login",
            token: this.getToken,
            content: newVal.id,
          };
          console.log("发送websocket登录信息");
          ws.send(JSON.stringify(params));
        }
      } else {
        if (ws && ws.readyState == 1) {
          let params = {
            type: "logout",
            token: "",
            content: "",
          };
          ws.send(JSON.stringify(params));
        }
      }
    },
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)

    // 获取单个参数
    const lang = urlParams.get('lang')
    if (lang == 'en') {
      this.lang = 'EN'
    }
    else this.lang = 'CN'

    getLangData({ lang: lang }).then(res => {
      this.setLangData(res.data)
    })

    getTipsLangData().then(res => {
      this.setTipsLangData(res.data)
    })
  },
  mounted() {

  },
  methods: {
    getWs() {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (_this.ws == null) {
          if ("WebSocket" in window) {
            _this.ws = new WebSocket(wsApi);
            _this.ws.onmessage = (res) => {
              let result = JSON.parse(res.data);
              _this.handleResult(result);
            };
            _this.ws.onopen = (res) => {
              console.log("socket connect success");
              resolve(_this.ws);
            };
          } else {
            reject(null);
            alert("Not support websocket");
          }
        } else resolve(_this.ws);
      });
    },
    handleResult(result) {
      if (result.show) {
        this.$notify({
          title: translateString(result.title + " 通知"),
          message: translateString(result.msg),
          type: result.level,
          position: "bottom-right",
        });
      }

      // 存在url，那就下载
      if (result.extra && result.extra.url != undefined) {
        let sList = result.extra.url.split('/')
        downloadFile(result.extra.url, sList[sList.length - 1])
      }

      // 当action存在时，则表示相应的内容需要刷新，相应页面需要混入refresh-page-mixin
      // action为一个数组，包含多个路由
      if (result.action) {
        this.notifyCount++;
        if (this.notifyCount >= 10) {
          this.notifyCount = 0;
        }

        let routeName = "";
        for (var i = 0; i < result.action.length; i++) {
          if (result.action[i] == "home") {
            routeName = this.$route.name;
            break;
          } else if (this.$route.name == result.action[i]) {
            routeName = result.action[i];
            break;
          }
        }

        this.setNotifyRefreshRouterKey(routeName + "_" + this.notifyCount);
      }
    },
    onClickLang() {
      // const { path, query } = this.$route
      let lang = "en"

      if (this.lang == 'EN') {
        lang = 'cn'
      }

      const url = new URL(window.location.href)
      url.searchParams.set('lang', lang)
      window.location.replace(url.toString())
    },
    ...mapActions(["setToken", "setProjectId", "setNotifyRefreshRouterKey", "setLangData", 'setTipsLangData']),
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
    }
  },
};
</script>
<style lang="less" scoped>
.lang-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 40px;
  height: 40px;
  background-color: rgb(255, 255, 255);
  border-radius: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  z-index: 10000;
}
</style>

<style lang="less">
body {
  margin: 0;
  padding: 0;
  background-color: #091841;
  font-size: 16px;
}

#app {
  position: relative;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// 默认的页面样式
.g-page {
  width: 100%;
  height: 100%;
  position: relative;
}

.g-nowrap-div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.g-input {
  width: 220px;
}

// 背景板颜色
.g-blue-bk {
  background: linear-gradient(to right, #0f2769, #102a70, #0f2769);
}

// 取消字体颜色
.g-cancel-color {
  color: #dadada;
}

// 深色el-dialog样式
.g-dark-dialog {
  .el-dialog {
    background: linear-gradient(to right, #0f2769, #102a70, #0f2769);
  }

  .el-dialog__body {
    color: #ffffff;
  }

  .el-dialog__title {
    color: #ffffff;
  }

  .el-form-item__label {
    color: #ffffff;
  }
}

// 深色form
.g-dark-form {
  .el-form-item__label {
    color: #ffffff;
  }
}

// 修改过的el-scrollbar样式
.g-scroller-bar {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  overflow-x: hidden;
}

// 深色下展示透明表格的样式
.g-dark-table {
  .el-table {
    color: #ffffff;
  }

  .el-table,
  .el-table__expanded-cell {
    background-color: transparent;
  }

  .el-table th.el-table__cell {
    background-color: #ececec;
    color: #909399;
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: bold;
  }

  .el-table tr {
    background-color: #0f2769;
  }

  .el-table--border::after {
    width: 0;
  }

  .el-table__header-wrapper {
    background: transparent;
  }

  .el-table tbody tr:hover>td {
    background-color: #1c40a5 !important;
    color: #ffffff !important;
  }

  .el-table__body tr.hover-row.current-row>td.el-table__cell,
  .el-table__body tr.hover-row.el-table__row--striped.current-row>td.el-table__cell,
  .el-table__body tr.hover-row>td.el-table__cell {
    color: #909399;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #091841;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #7575758c;
    transition: 0.3s ease-in-out;
  }

  ::-webkit-scrollbar-track {
    border-radius: 5px;
  }

  .el-table .select-row {
    background-color: #bdbdbd;
    color: #585858;
  }
}

// 普通页面展示表格的样式
.g-table-content {
  position: relative;
  margin: 10px 0;
  width: 100%;
  height: calc(100% - 50px - 50px - 10px * 2);
}

// 普通页面非表格样式
.g-content {
  position: relative;
  padding: 0;
  margin: 0;
  margin-top: 10px;
  height: calc(100% - 50px - 10px);
}

// 普通页面搜索栏的样式
.g-search-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 50px;

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #ffffff;
  }
}

// 普通页面操作栏的样式
.g-action-bar {
  height: 50px;
  padding: 0 10px;
  margin-top: 10px;
  display: flex;
  // flex-direction: column;
  align-items: center;
}

// 深色下的页码样式
.g-dark-pagination {
  overflow: hidden;

  .el-pagination button:disabled {
    background-color: transparent;
    color: #606266 !important;
  }

  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    background: center center no-repeat transparent;
    color: #ffffff;
  }

  .el-pagination .btn-next:hover,
  .el-pagination .btn-prev:hover {
    color: #409eff;
  }

  .el-pager li {
    background-color: transparent;
  }

  .el-pagination {
    color: #ffffff;
  }

  .el-pagination__total {
    color: #ffffff;
  }

  .el-pagination__jump {
    color: #ffffff;
  }

  .el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #ffffff;
  }

  .el-pager li.btn-quicknext:hover,
  .el-pager li.btn-quickprev:hover {
    color: #409eff;
  }
}

.el-popover {
  background: linear-gradient(to right, #0f2769, #102a70, #0f2769) !important;
  color: #ffffff !important;
}

.el-popover__title {
  color: #ffffff !important;
}

.g-horizontal-row {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue